import React from "react";
import { useLocation } from "react-router-dom";
import { useCms } from "../lib/cms";
import { track } from "../lib/pixel";

const PRESET_MESSAGE = "Hallo, ich interessiere mich für einen Umzug / Möbeltransport und möchte ein Angebot erhalten.";

export default function StickyWhatsAppCTA() {
  const { pathname } = useLocation();
  const { cms } = useCms();
  if (pathname.startsWith("/admin")) return null;

  const rawPhone = (cms?.legal?.impressum?.phone) || "+49 176 56198464";
  const digits = rawPhone.replace(/\D/g, "") || "4917656198464";
  const href = `https://wa.me/${digits}?text=${encodeURIComponent(PRESET_MESSAGE)}`;

  const onClick = () => {
    // Contact + Lead are already fired globally by the delegation in index.html
    // for every wa.me click. Keep only the custom event here for source attribution.
    track({ custom: "WhatsAppClicked", params: { source: "sticky_button" } });
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      aria-label="WhatsApp-Chat öffnen"
      title="WhatsApp-Chat öffnen"
      className="hidden md:grid fixed z-50 place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-floating hover:bg-[#1ebd5b] hover:scale-110 active:scale-95 transition-all
                 bottom-24 right-7"
      data-testid="sticky-whatsapp"
    >
      {/* WhatsApp glyph (SVG so it renders without an emoji font) */}
      <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" className="w-6 h-6 sm:w-7 sm:h-7">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.155-.146-.342-.347-.567-.617-.275-.317-.498-.62-.668-.91-.106-.18-.054-.345.155-.488.205-.142.387-.314.578-.486.146-.13.265-.27.319-.448.083-.272.066-.487-.054-.65-.144-.196-.39-.547-.737-1.058-.349-.508-.564-.793-.667-.793h-.515c-.27 0-.602.198-.602.198-.227.1-.422.345-.604.554-.357.41-.557.96-.557 1.622 0 .638.218 1.27.654 1.892.434.624.99 1.207 1.666 1.748.7.564 1.469 1.057 2.31 1.484.84.43 1.673.71 2.498.836a.95.95 0 0 0 .312.057c.527 0 .917-.16 1.166-.483.249-.323.373-.69.373-1.106 0-.247-.06-.385-.183-.46-.122-.073-.348-.13-.677-.17z M16 4C9.373 4 4 9.373 4 16c0 2.111.55 4.094 1.515 5.823L4 28l6.354-1.665A11.948 11.948 0 0 0 16 28c6.627 0 12-5.373 12-12S22.627 4 16 4zm0 22a9.95 9.95 0 0 1-5.073-1.385l-.363-.215-3.768.988 1.005-3.671-.236-.378A9.952 9.952 0 0 1 6 16c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10z"/>
      </svg>
    </a>
  );
}
